import { render, staticRenderFns } from "./billOverseasSSubmitView.vue?vue&type=template&id=76445c98&"
import script from "./billOverseasSSubmitView.vue?vue&type=script&lang=js&"
export * from "./billOverseasSSubmitView.vue?vue&type=script&lang=js&"
import style0 from "./billOverseasSSubmitView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76445c98')) {
      api.createRecord('76445c98', component.options)
    } else {
      api.reload('76445c98', component.options)
    }
    module.hot.accept("./billOverseasSSubmitView.vue?vue&type=template&id=76445c98&", function () {
      api.rerender('76445c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/billOverseasSSubmitView.vue"
export default component.exports